import * as fromModules from './modules.actions';
export interface ModuleState {
	module: string
}

const InitState: ModuleState = {
	module: null
};

export function ModuleReducer(state = InitState, action: fromModules.acciones): ModuleState {
	switch (action.type) {
		case fromModules.SET_CURRENT_MODULE:
			return { module: action.module };
		default:
			return state;
	}
}